import {StockPanelTabs} from '@Panels/stock-panel/stock-panel.types';

export type AiPanelKey = 'ai-images' | 'ai-stickers' | 'ai-videos' | 'ai-voice' | 'ai-all';

// Identifies this button's small-screen MoreOptionsModal in the modals hashmap, so its open state can be tracked and closed.
export const AI_TOOLS_MODAL_PANEL_ID = 'stock-ai-tools-modal';

export type StockAiButtonWidthMode = 'full' | 'content';

export interface StockAiButtonProps {
  isGridView: boolean;
  selectedTab: StockPanelTabs;
  tabsToShow: StockPanelTabs[];
  widthMode?: StockAiButtonWidthMode;
  onAiImages(): void;
  onAiStickers(): void;
  onAiVideos(): void;
  onAiVoice(): void;
}

// Maps each media tab to the AI tool that creates that kind of content. Tabs with no AI tool (Icons, Shapes) are absent,
// so the "Create with AI" CTA only ever offers tools relevant to the tabs the panel was opened with.
export const TAB_TO_AI_PANEL_KEY: Partial<Record<StockPanelTabs, AiPanelKey>> = {
  [StockPanelTabs.PHOTOS]: 'ai-images',
  [StockPanelTabs.TEXT_TO_IMAGE]: 'ai-images',
  [StockPanelTabs.STICKERS]: 'ai-stickers',
  [StockPanelTabs.VIDEOS]: 'ai-videos',
  [StockPanelTabs.AUDIOS]: 'ai-voice',
};

// Each tool carries two labels: dropdown rows (and the small-screen modal) name the tool plainly ("AI Videos"),
// while standalone CTA buttons (tab-grid mode, single-tool panels) keep the action wording ("Create AI Videos").
export interface AiDropdownItem {
  id: AiPanelKey;
  icon: string;
  dropdownLabelKey: string;
  ctaLabelKey: string;
  onClick(): void;
}
